module.exports = __webpack_public_path__ + "img/esmeralda-beach.575419af.jpg";